import React from 'react';
import { Row, Nav, Col, NavItem } from 'reactstrap';
import { Link } from 'react-router-dom';

import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';

import Css from './NavigationFooter.scss';
//import ThingsFrame from "@components/ExperiencesLandingPage/ThingsToDoTile/ThingsToDoTile";

const ExperiencesFooter = props => {
  const menu = [
    {
      label: 'Aspen',
      link: '/jetsuite-experiences/aspen'
    },
    {
      label: 'Charleston',
      link: '/jetsuite-experiences/charleston'
    },
    {
      label: 'D.C.',
      link: '/jetsuite-experiences/d-c'
    },
    {
      label: 'Dallas',
      link: '/jetsuite-experiences/dallas'
    },
    {
      label: 'Denver',
      link: '/jetsuite-experiences/denver'
    },
    {
      label: 'Miami',
      link: '/jetsuite-experiences/west-palm-beach-miami'
    },
    {
      label: 'Montreal',
      link: '/jetsuite-experiences/montreal'
    },
    {
      label: 'Napa',
      link: '/jetsuite-experiences/napa'
    },
    {
      label: 'Nashville',
      link: '/jetsuite-experiences/nashville'
    },
    {
      label: 'New York',
      link: '/jetsuite-experiences/new-york'
    },
    {
      label: 'San Diego',
      link: '/jetsuite-experiences/san-diego'
    },
    {
      label: 'San Francisco',
      link: '/jetsuite-experiences/san-francisco'
    },
    {
      label: 'Santa Barbara',
      link: '/jetsuite-experiences/santa-barbara'
    },
    {
      label: 'Scottsdale',
      link: '/jetsuite-experiences/scottsdale'
    },
    {
      label: 'Toronto',
      link: '/jetsuite-experiences/toronto'
    }
  ];

  const isMobile = window.innerWidth < 992;

  const menuItems = [];
  menu.forEach((cur, index) =>
    menuItems.push(
      <Col sm={12} md={4} key={index}>
        <NavItem>
          <Link
            to={cur.link}
            className={
              (isMobile ? 'py-1 d-block shadow-none ' : 'nav-link btn btn-fullred mb-3 shadow-none ') +
              (window.location.pathname === cur.link ? Css.active : '')
            }
            style={{boxShadown: 'none'}}
            onClick={() => {
              window.gtag('event', 'click', {
                event_category: 'JS-Experiences-Engagement',
                event_label: props.location + ' - ' + cur.label + ' - Click'
              });
            }}
          >
            {cur.label}
          </Link>
        </NavItem>
      </Col>
    )
  );
  return (
    <Row className={Css.ExperienceFooter + ' d-md-flex pb-2'}>
      <Col md={1}>
        <Nav className={'d-flex align-items-center h-100'}>
          {(props.hideNav === undefined || props.hideNav === false) && (
            <NavItem>
              <Link to="/jetsuite-experiences" className={'nav-link'}>
                <FontAwesomeIcon
                  icon={['far', 'chevron-left']}
                  className={'pointer'}
                  style={{ fontSize: '26px' }}
                />
              </Link>
            </NavItem>
          )}
        </Nav>
      </Col>
      <Col sm={12} md={10}>
        <Nav>
          <Row className={'text-center pt-2'}>{menuItems}</Row>
        </Nav>
      </Col>
    </Row>
  );
};
export default ExperiencesFooter;



// WEBPACK FOOTER //
// ./src/components/ExperiencesLandingPage/NavigationFooter/NavigationFooter.js